// removed by extract-text-webpack-plugin
module.exports = {"Items":"Items__Items__15Q8q"};


//////////////////
// WEBPACK FOOTER
// ./src/components/items/Items.css
// module id = 5942
// module chunks = 0